import { Alert, Button } from '@mui/material';
import TablerIconRefresh from '~icons/tabler/refresh';

export interface ChatMessageErrorProps {
  onRetry?: () => void;
}

function ChatMessageError({ onRetry }: ChatMessageErrorProps) {
  return (
    <Alert
      severity='error'
      variant='outlined'
      action={
        onRetry && (
          <Button
            size='small'
            variant='text'
            startIcon={<TablerIconRefresh />}
            color='inherit'
            onClick={onRetry}
          >
            Retry
          </Button>
        )
      }
    >
      An error occurred while fetching the chat. Please try again.
    </Alert>
  );
}

export default ChatMessageError;
